var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.imgLoading,
          expression: "imgLoading"
        }
      ],
      key: _vm.loopkey,
      ref: "move-box",
      class: { "signature-wrap": true, fixed: !!_vm.itemInfo.chapteFixed },
      style: _vm.handleSetChapte,
      attrs: { onpaste: "return false", tabindex: "0" }
    },
    [
      _c(
        "el-popover",
        {
          attrs: { placement: "right", width: "200", trigger: "manual" },
          model: {
            value: _vm.setPupVisi,
            callback: function($$v) {
              _vm.setPupVisi = $$v
            },
            expression: "setPupVisi"
          }
        },
        [
          _c(
            "div",
            [
              _c("h1", [
                _vm._v("设置变量\n        "),
                _c("i", {
                  staticClass: "el-icon-error close-sty",
                  on: {
                    click: function($event) {
                      _vm.setPupVisi = false
                    }
                  }
                })
              ]),
              _c("p", { staticClass: "var-setting" }, [_vm._v("印章名称")]),
              _c("el-input", {
                attrs: {
                  type: "text",
                  resize: "none",
                  maxlength: "20",
                  size: "mini",
                  placeholder: "填写印章名称",
                  row: 2,
                  value: _vm.itemInfo.signerAbc,
                  disabled: _vm.itemInfo.copy
                },
                on: { input: _vm.changeInputId }
              }),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.itemInfo.copy,
                      expression: "!itemInfo.copy"
                    }
                  ],
                  staticClass: "btns-sty"
                },
                [
                  _c(
                    "a",
                    { staticClass: "btn", on: { click: _vm.copyShowSetting } },
                    [_vm._v("复制")]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "btn",
                      on: {
                        click: function($event) {
                          return _vm.changeShowSetting(false)
                        }
                      }
                    },
                    [_vm._v("确定")]
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              class: [
                { "qz-new": true, draging: !!_vm.cachetMove },
                _vm.itemInfo.varType === _vm.flag.SIGN
                  ? "person-chap"
                  : _vm.itemInfo.varType === _vm.flag.SIGNNATURE
                  ? "ent-chap"
                  : "defalut-chap"
              ],
              attrs: { slot: "reference" },
              on: {
                click: function($event) {
                  return _vm.showSetHand(_vm.itemInfo)
                },
                "!mousedown": function($event) {
                  return _vm.handleCacheMousedown($event)
                }
              },
              slot: "reference"
            },
            [
              !_vm.itemInfo.chapteFixed && !_vm.imgLoading
                ? _c("a", {
                    staticClass: "el-icon-error del-chapter",
                    attrs: { href: "javascript:void (0)" },
                    on: { click: _vm.delItemInfo }
                  })
                : _vm._e(),
              _c(
                "div",
                { class: { "copy-sty": _vm.itemInfo.copy } },
                [
                  _c(
                    "h1",
                    {
                      style: {
                        background: [undefined, null].includes(
                          _vm.itemInfo.batch
                        )
                          ? "#ffa7a7"
                          : "#e6cc75"
                      }
                    },
                    [_vm._v(_vm._s(_vm.itemInfo.signerAbc))]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "con",
                      style: {
                        borderColor: [undefined, null].includes(
                          _vm.itemInfo.batch
                        )
                          ? "#ffa7a7"
                          : "#e6cc75"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("eclipse")(_vm.itemInfo.qsInfo)) +
                          "\n        "
                      )
                    ]
                  ),
                  !_vm.itemInfo.chapteFixed
                    ? _c("img", {
                        attrs: {
                          src: require("../../assets/images/move-icon.png")
                        }
                      })
                    : _vm._e(),
                  _c(
                    "span",
                    {
                      staticClass: "time",
                      style: {
                        color: [undefined, null].includes(_vm.itemInfo.batch)
                          ? "#ffa7a7"
                          : "#e6cc75"
                      }
                    },
                    [_vm._v("日期：XXXX")]
                  ),
                  !_vm.$route.query.apiPdf
                    ? _c(
                        "el-button",
                        {
                          staticClass: "batch-settings",
                          attrs: { plain: "", type: "primary", size: "mini" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.VISI = true
                            }
                          }
                        },
                        [_vm._v("批量设置")]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]
      ),
      _c("BatchSettingsPup", {
        attrs: {
          title: "印章批量设置",
          visible: _vm.VISI,
          width: "40%",
          appendToBody: true,
          VISI: _vm.VISI,
          items: _vm.items,
          BChapCurr: _vm.itemInfo,
          "before-close": function(done) {
            _vm.VISI = false
            done()
          }
        },
        on: {
          "update:visible": function($event) {
            _vm.VISI = $event
          },
          BatchSettinsClose: _vm.BSClose
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-616f8014", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-616f8014","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/advancedVersion/signature.vue
// module id = AVw5
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25